export default __webpack_public_path__ + "static/media/gwn44.8026b4ef.webp";